/* Cultishh fixes v8: sold-out sort + Flickity image swap + gallery image sizing + collection enhancements + PDP swatch styling + size swatch JS fix */
(function(){

  // -- SOLD-OUT SORT ---------------------------------------------------------
  function sortSoldOut(){
    if(!document.body.classList.contains('template-collection')) return;
    var grid=document.querySelector('.cs_products_holder');
    if(!grid) return;
    var cards=Array.from(grid.querySelectorAll('.pr_grid_item'));
    var soldOut=cards.filter(function(c){return !!c.querySelector('.out-of-stock');});
    if(!soldOut.length) return;
    var inStock=cards.filter(function(c){return !c.querySelector('.out-of-stock');});
    inStock.concat(soldOut).forEach(function(c){grid.appendChild(c);});
  }
  function scheduledSort(){
    sortSoldOut();
    setTimeout(sortSoldOut,800);
    setTimeout(sortSoldOut,1800);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scheduledSort);
  else scheduledSort();

  // -- GALLERY IMAGE SIZING --------------------------------------------------
  function addSizeSuffix(url,suffix){
    if(!url||url.indexOf(suffix)>-1) return url;
    return url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i,suffix+'$1$3');
  }
  function optimizeGalleryImageSizes(){
    document.querySelectorAll('.sp-pr-gallery__img').forEach(function(slide){
      var ds=slide.getAttribute('data-src');
      if(ds) slide.setAttribute('data-src',addSizeSuffix(ds,'_2000x'));
      var dbs=slide.getAttribute('data-bgset');
      if(dbs){
        var fixed=dbs.replace(/_1x1(\.(jpg|jpeg|png|gif|webp))(\?|$)/i,'_800x$1$3');
        if(fixed===dbs) fixed=addSizeSuffix(dbs,'_800x');
        slide.setAttribute('data-bgset',fixed);
      }
      slide.querySelectorAll('source[data-srcset]').forEach(function(src){
        var dss=src.getAttribute('data-srcset');
        if(dss) src.setAttribute('data-srcset',addSizeSuffix(dss,'_2000x'));
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',optimizeGalleryImageSizes);
  else optimizeGalleryImageSizes();

  // -- IMAGE SWAP ON COLOR SWATCH CLICK -------------------------------------
  function initImgSwap(){
    if(!window.__cltProductData) return;
    var imgMap={};
    (window.__cltProductData.variants||[]).forEach(function(v){
      if(!v.featured_image) return;
      var src=v.featured_image.src||'';
      var filename=src.split('?')[0].split('/').pop();
      var colorOption=v.options&&v.options[0]?v.options[0].toLowerCase():'';
      if(colorOption&&filename&&!imgMap[colorOption]) imgMap[colorOption]=filename;
    });
    if(!Object.keys(imgMap).length) return;
    document.addEventListener('click',function(e){
      var item=e.target.closest(
        '[data-opname="Color"] .swatch_pr_item,'+
        '[data-opname="color"] .swatch_pr_item,'+
        '[data-opname="Colour"] .swatch_pr_item,'+
        '[data-opname="colour"] .swatch_pr_item'
      );
      if(!item) return;
      var rawKey=item.dataset.value||'';
      if(!rawKey){
        var lbl=item.querySelector('.swatch__value_pr');
        rawKey=lbl?lbl.textContent.trim():'';
      }
      var key=rawKey.toLowerCase().replace(/-/g,' ');
      var filename=imgMap[key];
      if(!filename){
        for(var k in imgMap){
          if(key.indexOf(k)>-1||k.indexOf(key)>-1){filename=imgMap[k];break;}
        }
      }
      if(!filename) return;
      setTimeout(function(){
        var galleryEl=document.querySelector('.flickity-enabled');
        if(!galleryEl||!window.Flickity) return;
        var flkty=Flickity.data(galleryEl);
        if(!flkty) return;
        var slides=Array.from(document.querySelectorAll('.sp-pr-gallery__img'));
        var targetIdx=-1;
        slides.forEach(function(s,i){
          var dataSrc=s.getAttribute('data-src')||s.getAttribute('data-bgset')||'';
          if(dataSrc.indexOf(filename)>-1) targetIdx=i;
        });
        if(targetIdx>-1) flkty.select(targetIdx);
      },80);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initImgSwap);
  else initImgSwap();

  // -- COLLECTION PAGE ENHANCEMENTS -----------------------------------------
  function initCollectionSwatches(){
    if(!document.body.classList.contains('template-collection')) return;
    var css=document.createElement('style');
    css.textContent=
      '.cs_swatches_on_grid{display:none!important}'+
      '.clt-swatches{display:flex;flex-wrap:wrap;align-items:center;gap:3px;margin-top:7px;padding:0 2px;min-height:18px}'+
      '.clt-sw-color{width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,0.18);display:inline-block;flex-shrink:0;box-sizing:border-box}'+
      '.clt-sw-size{font-size:9px;letter-spacing:.05em;text-transform:uppercase;color:#555;border:1px solid #d5d5d5;padding:1px 4px;line-height:15px;font-family:inherit;background:#f3f3f3;display:inline-block;box-sizing:border-box}'+
      '.clt-sw-sep{width:1px;height:10px;background:#ccc;display:inline-block;margin:0 2px;vertical-align:middle}'+
      '.clt-hover-img{position:absolute;inset:0;background-size:cover;background-position:center top;opacity:0;transition:opacity .35s ease;pointer-events:none;z-index:2}'+
      '.product-image:hover .clt-hover-img{opacity:1}'+
      '.clt-badge{position:absolute;top:10px;left:10px;z-index:5;font-size:9px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;padding:3px 8px;pointer-events:none;line-height:1.5;font-family:inherit}'+
      '.clt-badge--soldout{background:#111;color:#fff}'+
      '.clt-badge--limited{background:#fff;color:#111;border:1px solid rgba(0,0,0,0.25)}'+
      '.clt-badge--preorder{background:#b8975a;color:#fff}'+
      '.clt-badge--new{background:#111;color:#fff}'+
      '.clt-item-count{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#999;margin-bottom:16px;display:block}';
    document.head.appendChild(css);
    var colorCache={};
    function resolveSwatchColor(colorKey){
      if(colorKey in colorCache) return colorCache[colorKey];
      var el=document.createElement('span');
      el.className='swatch__value_pr bg_color_'+colorKey;
      el.style.cssText='position:absolute;visibility:hidden;width:10px;height:10px;top:-999px';
      document.body.appendChild(el);
      var bg=window.getComputedStyle(el).backgroundColor;
      document.body.removeChild(el);
      var color=(bg&&bg!=='rgba(0, 0, 0, 0)'&&bg!=='transparent')?bg:'';
      colorCache[colorKey]=color;
      return color;
    }
    var parts=window.location.pathname.replace(/^\/|\/$/g,'').split('/');
    var ci=parts.indexOf('collections');
    if(ci<0||!parts[ci+1]) return;
    var collHandle=parts[ci+1];
    fetch('/collections/'+collHandle+'/products.json?limit=250')
      .then(function(r){return r.json();})
      .then(function(data){
        var products=data.products||[];
        var productMap={};
        products.forEach(function(p){
          var colorIdx=-1,sizeIdx=-1;
          (p.options||[]).forEach(function(o,i){
            var n=o.name.toLowerCase();
            if(n==='color'||n==='colour') colorIdx=i;
            if(n==='size') sizeIdx=i;
          });
          var colors=[],sizes=[],seenC={},seenS={};
          (p.variants||[]).forEach(function(v){
            if(colorIdx>=0){var c=v['option'+(colorIdx+1)];if(c&&!seenC[c]){seenC[c]=1;colors.push(c);}}
            if(sizeIdx>=0){var s=v['option'+(sizeIdx+1)];if(s&&!seenS[s]){seenS[s]=1;sizes.push(s);}}
          });
          var secondImg='';
          if(p.images&&p.images[1]){
            secondImg=p.images[1].src.split('?')[0].replace(/(\.(jpg|jpeg|png|gif|webp))$/i,'_800x$1');
          }
          var tags=(p.tags||[]).map(function(t){return t.toLowerCase().trim();});
          productMap[p.handle]={colors:colors,sizes:sizes,secondImg:secondImg,tags:tags};
        });
        if(products.length>0&&!document.querySelector('.clt-item-count')){
          var grid=document.querySelector('.cs_products_holder');
          if(grid){
            var countEl=document.createElement('span');
            countEl.className='clt-item-count';
            countEl.textContent=products.length+(products.length===250?'+':'')+' ITEMS';
            grid.parentNode.insertBefore(countEl,grid);
          }
        }
        document.querySelectorAll('.pr_grid_item').forEach(function(card){
          var link=card.querySelector('a[href*="/products/"]');
          if(!link) return;
          var m=link.href.match(/\/products\/([^?#\/]+)/);
          if(!m) return;
          var pData=productMap[m[1]];
          if(!pData) return;
          var imgContainer=card.querySelector('.product-image');
          var swatchContainer=card.querySelector('.cs_swatches_on_grid');
          var nextSib=swatchContainer&&swatchContainer.nextElementSibling;
          if(swatchContainer&&!(nextSib&&nextSib.classList.contains('clt-swatches'))&&(pData.colors.length+pData.sizes.length>0)){
            var html='<div class="clt-swatches">';
            if(pData.colors.length){
              pData.colors.forEach(function(c){
                var key=c.toLowerCase().replace(/[\s\/]+/g,'-');
                var bgColor=resolveSwatchColor(key);
                html+='<span class="clt-sw-color" style="'+(bgColor?'background:'+bgColor+';':'background:#e0e0e0;')+'" title="'+c+'"></span>';
              });
              if(pData.sizes.length) html+='<span class="clt-sw-sep"></span>';
            }
            pData.sizes.forEach(function(s){html+='<span class="clt-sw-size">'+s+'</span>';});
            swatchContainer.insertAdjacentHTML('afterend',html+'</div>');
          }
          if(!imgContainer) return;
          imgContainer.style.position='relative';
          if(pData.secondImg&&!card.querySelector('.clt-hover-img')){
            var hoverDiv=document.createElement('div');
            hoverDiv.className='clt-hover-img';
            hoverDiv.style.backgroundImage='url("'+pData.secondImg+'")';
            imgContainer.appendChild(hoverDiv);
          }
          if(!card.querySelector('.clt-badge')){
            var badgeText=null,badgeCls=null,tags=pData.tags;
            var isSoldOut=!!card.querySelector('.out-of-stock');
            if(isSoldOut){badgeText='SOLD OUT';badgeCls='clt-badge--soldout';}
            else if(tags.some(function(t){return t==='limited-edition'||t==='limited edition'||t==='limited';})){badgeText='LIMITED EDITION';badgeCls='clt-badge--limited';}
            else if(tags.some(function(t){return t==='pre-order'||t==='preorder'||t==='pre order';})){badgeText='PRE-ORDER';badgeCls='clt-badge--preorder';}
            else if(tags.some(function(t){return t==='new-arrival'||t==='new arrival'||t==='new';})){badgeText='NEW';badgeCls='clt-badge--new';}
            if(badgeText){
              var badge=document.createElement('div');
              badge.className='clt-badge '+badgeCls;
              badge.textContent=badgeText;
              imgContainer.appendChild(badge);
            }
          }
        });
      }).catch(function(){});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCollectionSwatches);
  else initCollectionSwatches();

  // -- PRODUCT PAGE SWATCH STYLING ------------------------------------------
  function initProductPageStyles(){
    if(!document.body.classList.contains('template-product')) return;
    var css=document.createElement('style');
    css.textContent=
      '.cs_select_ppr0 ul.swatches-select,.cs_select_ppr0 ul.swatch__list_pr{display:flex!important;flex-wrap:wrap!important;gap:6px!important;padding:0!important;margin:8px 0 0!important;list-style:none!important}'+
      '.cs_select_ppr0 li.swatch_pr_item{width:28px!important;height:28px!important;min-width:28px!important;border:none!important;border-radius:50%!important;padding:2px!important;box-shadow:inset 0 0 0 1px rgba(0,0,0,0.12)!important;cursor:pointer!important;box-sizing:border-box!important;background:transparent!important;display:flex!important;align-items:center!important;justify-content:center!important}'+
      '.cs_select_ppr0 li.swatch_pr_item.is-selected-cs{box-shadow:0 0 0 2px #fff,0 0 0 4px #111!important}'+
      '.cs_select_ppr0 li.swatch_pr_item .swatch__value_pr{width:100%!important;height:100%!important;border-radius:50%!important;border:none!important;display:block!important}'+
      '.cs_select_ppr0 h4.swatch__title{font-size:11px!important;letter-spacing:.12em!important;text-transform:uppercase!important;font-weight:500!important;margin-bottom:6px!important}'+
      '.cs_select_ppr1 ul.swatches-select,.cs_select_ppr1 ul.swatch__list_pr{display:flex!important;flex-wrap:wrap!important;gap:6px!important;padding:0!important;margin:8px 0 0!important;list-style:none!important}'+
      '.cs_select_ppr1 li.swatch_pr_item{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:auto!important;min-width:44px!important;height:36px!important;padding:0 12px!important;border:1px solid #d5d5d5!important;border-radius:0!important;font-size:11px!important;letter-spacing:.06em!important;text-transform:uppercase!important;cursor:pointer!important;box-sizing:border-box!important;background:#fff!important;color:#111!important;font-family:inherit!important;font-weight:400!important}'+
      '.cs_select_ppr1 li.swatch_pr_item.is-selected-cs{background:#111!important;color:#fff!important;border-color:#111!important}'+
      '.cs_select_ppr1 li.swatch_pr_item:not(.is-selected-cs):hover{border-color:#111!important}'+
      '.cs_select_ppr1 h4.swatch__title{font-size:11px!important;letter-spacing:.12em!important;text-transform:uppercase!important;font-weight:500!important;margin-bottom:6px!important}'+
      '.cs_select_ppr1 li.swatch_pr_item .swatch__value_pr{font-size:inherit!important;color:inherit!important;background:none!important;border:none!important;width:auto!important;height:auto!important}';
    document.head.appendChild(css);

    // Force-show size swatch UL — theme JS sets inline display:none!important
    // CSS !important cannot beat inline !important, so we use JS to override.
    function showSizeSwatches(){
      document.querySelectorAll('.cs_select_ppr1 ul.swatches-select,.cs_select_ppr1 ul.swatch__list_pr').forEach(function(ul){
        ul.style.setProperty('display','flex','important');
        var ppr=ul.closest('.cs_select_ppr1');
        var sel=ppr&&ppr.querySelector('select');
        if(sel) sel.style.setProperty('display','none','important');
      });
    }
    showSizeSwatches();
    setTimeout(showSizeSwatches,50);
    setTimeout(showSizeSwatches,200);
    setTimeout(showSizeSwatches,600);

    function formatSwatchLabels(){
      document.querySelectorAll('.cs_select_ppr0 h4.swatch__title,.cs_select_ppr1 h4.swatch__title').forEach(function(h4){
        if(h4.dataset.cltFormatted) return;
        h4.dataset.cltFormatted='1';
        var txt=h4.textContent||'';
        var colon=txt.indexOf(':');
        if(colon<0) return;
        var label=txt.slice(0,colon).trim().toUpperCase();
        var value=txt.slice(colon+1).trim();
        h4.innerHTML='<span style="letter-spacing:.12em;font-weight:500">'+label+'</span><span style="margin:0 5px;opacity:.35"> · </span><span class="clt-swatch-val" style="font-weight:400;text-transform:none;letter-spacing:0">'+value+'</span>';
      });
    }
    formatSwatchLabels();

    // Watch H4 labels for theme text updates, AND watch size UL style attr
    // so we can re-show it if theme re-hides it after variant selection.
    var obs=new MutationObserver(function(muts){
      muts.forEach(function(m){
        if(m.type==='attributes'&&m.attributeName==='style'){
          showSizeSwatches();
          return;
        }
        if(m.type==='characterData'||m.type==='childList'){
          var h4=m.target.nodeType===1?m.target.closest('h4.swatch__title'):(m.target.parentNode&&m.target.parentNode.closest?m.target.parentNode.closest('h4.swatch__title'):null);
          if(h4){h4.dataset.cltFormatted='';formatSwatchLabels();}
        }
      });
    });
    document.querySelectorAll('h4.swatch__title').forEach(function(h4){
      obs.observe(h4,{childList:true,characterData:true,subtree:true});
    });
    document.querySelectorAll('.cs_select_ppr1 ul.swatches-select,.cs_select_ppr1 ul.swatch__list_pr').forEach(function(ul){
      obs.observe(ul,{attributes:true,attributeFilter:['style']});
    });
  }


})();
